// Import From sankeyDev
import * as  HideLoneNodeFunction from 'sankeydev/dist/src/HideLoneNodeFunction'
import * as PercentValue from 'sankeydev/dist/src/PercentValue'
import * as LicenceBlockers from 'sankeydev/dist/src/LicenceBlockers'
import * as SankeyDevUnitarySankey from 'sankeydev/dist/src/SankeyDevUnitarySankey'
import * as PublishModale from 'sankeydev/dist/src/PublishModale'
import * as MenuExampleDemo from 'sankeydev/dist/src/MenuExampleDemo'
import * as DevMenuEnregistrerExcelSimple from 'sankeydev/dist/src/MenuEnregistrerExcelSimple'
import * as NodeNotToScale from 'sankeydev/dist/src/NodeNotToScale'

import { MenuConfigHideLoneNodeFType, hiddeLoneNodesFType, searchAndRestoreLoneNodesFType} from 'sankeydev/types/HideLoneNodeFunctionTypes'
import { SankeyDevMenuDataPercentFType, devGetLinkValueFType } from 'sankeydev/types/PercentValueTypes'
import { blockers_suite_sankeyFType} from 'sankeydev/types/LicenceBlockersTypes'
import { SankeyDevBannerUnitsFType, SankeyDev_legend_elementsFType, SankeyDev_link_textFType, context_node_view_node_unitaryFType} from 'sankeydev/types/SankeyDevUnitarySankeyTypes'
import { PublishModalTypes, SankeyDevMenuPublishItemFType } from 'sankeydev/types/PublishModaleTypes'
import { MenuEnregistrerExcelSimpleFType } from 'sankeydev/types/MenuEnregistrerExcelSimpleTypes'
import { SankeyDevDrawNodesNotToScaleFType, SankeyDevNodesAttributesFType } from 'sankeydev/types/NodeNotToScaleTypes'
import { itemDemoFType } from 'sankeydev/types/MenuExampleDemoTypes'
import { FunctionComponent } from 'react'
import * as SankeyIconsUtils from 'sankeyicons/dist/SankeyIconsUtils'
import {ModalSelectionIconsType} from 'sankeyicons/src/SankeyIconsUtils'

export const hiddeLoneNodes =
    HideLoneNodeFunction.hiddeLoneNodes as hiddeLoneNodesFType
export const searchAndRestoreLoneNodes =
    HideLoneNodeFunction.searchAndRestoreLoneNodes as searchAndRestoreLoneNodesFType
export const MenuConfigHideLoneNode =
    HideLoneNodeFunction.MenuConfigHideLoneNode as MenuConfigHideLoneNodeFType
export const devGetLinkValue =
    PercentValue.devGetLinkValue as devGetLinkValueFType
export const SankeyDevMenuDataPercent =
    PercentValue.SankeyDevMenuDataPercent as SankeyDevMenuDataPercentFType
export const blockers_suite_sankey =
    LicenceBlockers.blockers_suite_sankey as blockers_suite_sankeyFType
export const itemDemo =
    MenuExampleDemo.itemDemo as itemDemoFType
export const MenuEnregistrerExcelSimple =
    DevMenuEnregistrerExcelSimple.MenuEnregistrerExcelSimple as MenuEnregistrerExcelSimpleFType
export const SankeyDevNodesAttributes =
    NodeNotToScale.SankeyDevNodesAttributes as SankeyDevNodesAttributesFType
export const SankeyDevBannerUnit =
    SankeyDevUnitarySankey.SankeyDevBannerUnit as SankeyDevBannerUnitsFType
export const context_node_view_node_unitary =
    SankeyDevUnitarySankey.context_node_view_node_unitary as context_node_view_node_unitaryFType
export const SankeyDev_link_text =
    SankeyDevUnitarySankey.SankeyDev_link_text as SankeyDev_link_textFType
export const SankeyDev_legend_elements =
    SankeyDevUnitarySankey.SankeyDev_legend_elements as SankeyDev_legend_elementsFType
export const SankeyDevMenuPublishItem =
    PublishModale.SankeyDevMenuPublishItem as SankeyDevMenuPublishItemFType
export const PublishModal :FunctionComponent<PublishModalTypes> =
    PublishModale.PublishModal 
export const modal_selection_icons:ModalSelectionIconsType
    = SankeyIconsUtils.modal_selection_icons

export const SankeyDevDrawNodesNotToScale:SankeyDevDrawNodesNotToScaleFType=NodeNotToScale.SankeyDevDrawNodesNotToScale